import { Heading } from '@chakra-ui/react';

export function Analytics() {
  return <Heading size={'md'}>Analytics</Heading>;
}
